module.exports = __webpack_public_path__ + "static/media/DSCN0332.0e2c2a3f.jpg";